import { win } from "../../../common/namespaces.js";

/**
 *
 *
 *
 */
export const getAssignments = (): Promise<App.Onex> =>
  new Promise<App.Onex>((resolve) => {
    const unsub = win.otto.onex.assignments.sub((v) => {
      if (v) {
        resolve(v);
        unsub();
      }
    });
  });
